<body>
    <div>
        <div class="center-container">
            <div class="content-area">
                <!-- Stepper - Sidebar -->
                <div class="sidebar">
                    <div *ngIf="!isEditMode" class="role-title">Create a new scenario</div>
                    <div *ngIf="isEditMode" class="role-title">Editing {{ scenario_name }}</div>
                    <app-stepper [isEditMode]="isEditMode" (changeStepperEvent)="changeStepper($event)"></app-stepper>
                </div>
                <!-- Form Elements-->
                <div class="container">
                    <!-- Form Elements-->
                    <div class="inner-container">
                        <form [formGroup]="step2Form"> <!-- (ngSubmit)="next()" -->
                            <div class="title">
                                <div class="tell-us-block">
                                    <span class="paraTell">Define Objectives for Trainee(Field Rep)</span>
                                </div>
                                <div class="inner-block">
                                    <div class="cust">
                                        <label class="labels">Objectives:</label>
                                    </div>
                                    <div formArrayName="objectives">
                                        <div class="cust row-1"
                                            *ngFor="let objective of objectives.controls; let i = index">
                                            <input class="input-box" type="text" [formControlName]="i"
                                                placeholder="Add new Objective">
                                            <img class="jj-close" (click)="removeObjective(i)"
                                                src="../../../../assets/images/JJ_Icon_Close.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="checkbox-list">
                                        <button type="button" (click)="addObjective()">Add new +</button>
                                    </div>

                                    <div *ngIf="formSubmitted && step2Form.errors?.['atLeastOneRequired']">
                                        <p style="color: red;">Please fill one objective.</p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="cancel-button" (click)="goBack()">&times;</div>
            </div>
            <div class="footer-step1">
                <div class="secondary-button" (click)="goToStep(1)">
                    <div>Previous</div>
                </div>
                <div class="primary-button" (click)="goToStep(3)">
                    <div>Next</div>
                </div>
            </div>
        </div>
    </div>
</body>